/** Default software logo (Edupro) — served from /public/logoo.png */
export const APP_LOGO = `${process.env.PUBLIC_URL || ''}/logoo.png`;
export const APP_LOGO_ALT = 'Edupro';

/** App shell gradient (sidebar + top bar) */
export const APP_SHELL_GRADIENT =
  'bg-gradient-to-b from-forma-800 via-forma-700 to-forma-600';
export const APP_SHELL_GRADIENT_H =
  'bg-gradient-to-r from-forma-800 via-forma-700 to-forma-600';
export const APP_SHELL_BORDER = 'border-forma-900/50';

/** Org logo from Paramètres, or software logo when none is configured. */
export function resolveBrandLogo(orgLogo) {
  return orgLogo || APP_LOGO;
}
